import React from 'react';
import { Routes, Route } from 'react-router-dom';

import RequireAuth from 'helpers/components/require-auth';
import OktaLogin from 'containers/login/okta-widget/okta-login';
import MaintenancePage from 'containers/maintenance-page';
import AuthenticatedApp from 'containers/authenticated-app';
import EnrollAccount from 'containers/enroll/enroll-account';
import ResetPassword from 'containers/reset-password';
import RequestPassword from 'containers/request-password';
import ToastContainer from 'components/partials/toast/toast-container/toast-container';

import { FeatureFlagsProvider } from 'components/shared/feature-flags';

const AppRoutes: React.FC = () => (
  <Routes>
    <Route path="/login/*" element={<OktaLogin />} />
    <Route path="/implicit" element={<OktaLogin />} />
    <Route path="/implicit/callback" element={<OktaLogin />} />
    <Route
      path="/account/:oktaUserId/:activationKey"
      element={<EnrollAccount />}
    />
    <Route path="/account/reset" element={<ResetPassword />} />
    <Route
      path="/account/request-password-reset"
      element={<RequestPassword />}
    />

    <Route
      path="/*"
      element={
        <RequireAuth>
          <MaintenancePage>
            <AuthenticatedApp />
          </MaintenancePage>
        </RequireAuth>
      }
    />
  </Routes>
);

const App: React.FC = () => (
  <FeatureFlagsProvider>
    <ToastContainer />
    <AppRoutes />
    <div id="menu-portal"></div>
    <div id="page-overlay"></div>
    <div id="modal-overlay"></div>
  </FeatureFlagsProvider>
);

export default App;
